export default "__VITE_ASSET__Caa38S71__"